/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const UploadCSV = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 28 27">
      <path
        d="M9.61804 8.55581L14 4.17383L18.382 8.55581"
        stroke="white"
        strokeWidth="1.66932"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 15.8591V4.17383" stroke="white" strokeWidth="1.66932" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M23.1813 15.8574V21.7001C23.1813 21.9214 23.0934 22.1337 22.9368 22.2903C22.7803 22.4468 22.568 22.5347 22.3466 22.5347H5.65339C5.43202 22.5347 5.21972 22.4468 5.06319 22.2903C4.90666 22.1337 4.81873 21.9214 4.81873 21.7001V15.8574"
        style={{fill: "transparent"}}
        stroke="white"
        strokeWidth="1.66932"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvgIcon>
  )
}

export default UploadCSV
